import { api } from "../api";

export interface ContactInquiryPayload {
  name: string;
  email: string;
  subject?: string;
  message: string;
}

export interface ContactInquiryResponse {
  success: boolean;
  message: string;
}

export const contactApi = {
  submit: async (payload: ContactInquiryPayload): Promise<ContactInquiryResponse> => {
    const response = await api.post<ContactInquiryResponse>("/contact", payload);
    return response.data;
  },
};
